import {usePageContext} from "vike-react/usePageContext";

export function Link({to, className, children}) {
  const pageContext = usePageContext()
  if (to.startsWith('?'))
    to = pageContext.urlPathname + to
  return <a href={to} className={className}>{children}</a>
}
